import { stat } from "fs";

export default {
  // Return all the data for a given cat given a specific cat's id
  getById: (state) => (id) => {
    //console.log("In store getById (id): " + id) //On page reload the 'id' IS defined
    //console.log("IN store getById (state.data.find): " + JSON.stringify(state.data.find(tkcat => tkcat.tkid === id)))
    /* console.log("-----> " + JSON.stringify(state.data.find(tkcat =>
      {
        console.log("In data.find with tkcat.tkid: " + tkcat.tkid)
        tkcat.tkid === id
      }
      ))) //On page reload this is undefined
    */
    return state.data.find(tkcat => tkcat.tkid === id)
  },
  // Return all the data for a specific cat given the cat's tkname
  getByName: (state) => (tkname) => {
    return state.data.find(tkcat => tkcat.tkname === tkname)
  },
  getAllData: (state) => {
    //Return data sorted in alphabetical order by tkname
    return state.data.sort((a,b) => {
      if (a.tkname < b.tkname)
        return -1;
      if (a.tkname > b.tkname)
         return 1;
      return 0;
    });
  },
  getStories: (state) => (id) => {
     if( state.data.find(tkcat => tkcat.tkid === id) ) {
        return state.data.stories
     }
  },

  // Used by TkBioListView.vue to get the id, tkname, tkinfo, and avatar picture.
  // The id and tkname will be passed to TkProfileView.vue
  getBioData: (state) => {
    //Not Working
    const obj = {
      id: state.data.id
    }
    return obj
  },
  // Not working yet. Need to return just the specific tkname pictgrid
  // array to TkPictGridView.vue .
  getPictGird: (state) => (tkname) => {
    return state.data.find(tkcat => tkcat.tkname === tkname)
  },
}


// WEBPACK FOOTER //
// ./src/store/getters.js